import React, {Component} from 'react';
import {connect} from 'react-redux';

import {
    Collapse,
    Row,
    Table
} from 'reactstrap';

import PolyUtil from '../../../../util/PolyUtil';
import CircleButton from "../../../../components/controls/buttons/CircleButton";
import {setShowAddHistory} from "../../actions/appDisplay";
import BoolButtons from "../../../../components/controls/buttons/BoolButtons";
import {incFlowKey} from "../../../../store/actions/display";
import AddEmploymentHistoryForm from "./forms/AddEmploymentHistoryForm";
import {handleRemoveEmploymentHistory} from "../../actions/application";
import EditEmploymentHistoryForm from "./forms/EditEmploymentHistoryForm";

class EmploymentFrame extends Component {
    state = {
        showAddHistory: false,
        skip: !PolyUtil.validArr(this.props.employment_history),
        editing: null
    };

    advance = () => {
        this.props._progressFrame();
    };

    setSkip = (skip) => {
        this.setState({skip: false});
    };

    setShowAddHistory = (show) => {
        this.setState({showAddHistory: show});
    };

    setEditing = (editing) => {
        this.setState({editing: this.state.editing === editing ? null : editing, showAddHistory: false});
    };

    render() {
        const showAddHistory = this.state.showAddHistory;
        const setEditing = this.setEditing;
        const {_handleRemoveEmploymentHistory, employment_history} = this.props;

        const hasHistory = PolyUtil.validArr(employment_history);
        const showAddForm = ((showAddHistory || !hasHistory) && !this.state.editing);

        return (
            <div>
                {
                    !this.state.skip ? (
                        <div>
                            <Row>
                                <h3>{!hasHistory ? "Great! Paint us a picture of your career" : "Here's your employment history so far"}</h3>
                            </Row>
                            <hr/>
                            <p>Adding your employment history is a great way to show that you’ll be a responsible tenant. Landlords also like to get an idea of where the rent money's coming from.</p>
                            {
                                hasHistory && (
                                    <span>
                                        <Table hover responsive>
                                            <thead>
                                            <tr>
                                                <th>Title</th>
                                                <th>Company</th>
                                                <th>Income</th>
                                                <th>City</th>
                                                <th>Dates</th>
                                                <th></th>
                                                <th></th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            {
                                                employment_history.map(function (item, i) {
                                                    return (
                                                        <tr className="animated fadeIn" key={i}>
                                                            <th scope="row">{item.title}</th>
                                                            <td>{item.employer_name}</td>
                                                            <td>{PolyUtil.formatUSD(item.gross_income)}</td>
                                                            <td>{item.employer_city}</td>
                                                            <td>{PolyUtil.formatDate(item.start_date) + " to " + (PolyUtil.formatDate(item.end_date) || 'Current')}</td>
                                                            <td>
                                                                <CircleButton type="button"
                                                                              style={{margin: '0'}}
                                                                              color="info"
                                                                              onClick={() => setEditing(item.id)}
                                                                              outline>
                                                                    <i className="fa fa-pencil"></i>
                                                                </CircleButton>
                                                            </td>
                                                            <td>
                                                                <CircleButton type="button"
                                                                              style={{margin: '0'}}
                                                                              color="danger"
                                                                              onClick={() => _handleRemoveEmploymentHistory(item.id)}
                                                                              outline>
                                                                    <i className="fa fa-minus"></i>
                                                                </CircleButton>
                                                            </td>
                                                        </tr>
                                                    );
                                                })
                                            }
                                            </tbody>

                                        </Table>
                                        {
                                            !showAddHistory && !this.state.editing && (
                                                <div className="center">
                                                    <CircleButton color="success" onClick={() => this.setShowAddHistory(true)} outline><i className="fa fa-plus"></i></CircleButton>
                                                </div>
                                            )
                                        }
                                    </span>
                                )
                            }
                            {
                                showAddForm && (
                                    <Collapse isOpen={showAddForm} style={{marginTop: '2em'}}>
                                        <AddEmploymentHistoryForm onAdd={() => this.setShowAddHistory(false)}/>
                                    </Collapse>
                                )
                            }

                            <Collapse isOpen={!!this.state.editing} style={{marginTop: '2em'}}>
                                {
                                    this.state.editing && <EditEmploymentHistoryForm onAdd={() => this.setEditing(null)} editing={this.state.editing}/>
                                }
                            </Collapse>
                        </div>
                    ) : (
                        <div>
                            <Row>
                                <h3>Would you like to add your employment history?</h3>
                            </Row>
                            <hr/>
                            <p>Employment history is optional but highly recommended. It’s a great way to show that you’ll be a responsible tenant.</p>
                            <BoolButtons width="7em" size="lg" falseText="No thanks" trueText="Yep!" onTrue={() => this.setSkip(false)} onFalse={this.advance}/>
                        </div>
                    )
                }
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    employment_history: state.tenant.application.employment_history_positions,
});

const mapDispatchToProps = (dispatch) => {
    return {
        _handleRemoveEmploymentHistory(id) {
            dispatch(handleRemoveEmploymentHistory(id));
        },
        _setShowAddHistory(show) {
            dispatch(setShowAddHistory(show));
        },
        _progressFrame() {
            dispatch(incFlowKey("tenant_application"));
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(EmploymentFrame);



// WEBPACK FOOTER //
// ./src/containers/tenant/application/frames/EmploymentFrame.js